export default "\n\n\n<router-outlet></router-outlet>"